var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"page-header",attrs:{"src":_vm.headerImage,"alt":"Header"}})}
var staticRenderFns = []

export { render, staticRenderFns }